<template>
  <div>
    <div>
      <TopBar :msg="titName" :pageNum="backNum"></TopBar>
    </div>
    <div style="text-align: left; padding: 0 10px">
      <van-steps :active="data.active">
        <van-step><span @click="linkToSet()">扫码设置</span></van-step>
        <van-step>扫码退货</van-step>
      </van-steps>
    </div>

    <transition name="slide-fade">
      <div v-show="data.active === 0">
        <SetScan :data="data" @changeData="getChildData"></SetScan>
      </div>
    </transition>

    <transition name="slide-fade">
      <div v-show="data.active === 1">
        <BackScan :data="data" @subListData="getChildListData"></BackScan>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { Button, List, Cell, Toast, Empty, Step, Steps } from "vant";
import TopBar from "../../components/TopBar";
import SetScan from "../../views/backScan/Set";
import BackScan from "../../views/backScan/Scan";

export default {
  data() {
    return {
      titName: "退货入库采集",
      backNum: -1,
      list: [],
      loading: false,
      finished: false,
      data: {
        active: 0,
        cRemark: "",
        cReturnGoodsBatchNo: "",
      },
    };
  },
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    [Empty.name]: Empty,
    [Step.name]: Step,
    [Steps.name]: Steps,
    TopBar: TopBar,
    SetScan: SetScan,
    BackScan: BackScan,
  },
  methods: {
    getChildData(params) {
      this.data = params;
    },
    getChildListData(params) {
      this.list = params;
    },
    linkToSet() {
      if (this.list.length > 0) {
        Toast.fail("已扫码 无法回退");
        return;
      }
      this.data = {
        active: 0,
        fCustomerInfoId: 0,
        cRemark: "",
      };
    },
  },
};
</script>
<style scoped>
</style>
